var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPublishingBadgeColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.9 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient--publishing",
    x1: 3.58,
    y1: -991.41,
    x2: 28.24,
    y2: -1016.07,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -987.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#787882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f5f69"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "publishing-badge-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.9,8.2a7.4,7.4,0,0,0-4.8,1.7l-.3-.7c-.1-.4-.5-.7-.8-.6h-.9a.9.9,0,0,0-.8.8v21a.9.9,0,0,0,.8.9H42a.8.8,0,0,0,.9-.8c.1,0,.1,0,.1-.1V23.6a7.9,7.9,0,0,0,3.7,1c4.2,0,7.6-3.6,7.6-8.2S51,8.2,46.9,8.2Zm-4,5.5a4.2,4.2,0,0,1,3.5-2c2.5,0,4.2,2,4.2,4.7a4.4,4.4,0,0,1-4.2,4.7h-.1a6.7,6.7,0,0,1-3.4-1Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9,8.6H67.2c-.5,0-1,0-1,.8v9.3a3.5,3.5,0,0,1-3.4,2.4c-2,0-2.9-1.1-2.9-3.5V9.4a.9.9,0,0,0-.9-.8H57.2a.9.9,0,0,0-.9.8v8c0,3.3.7,7.2,5.9,7.2a6.3,6.3,0,0,0,4.8-2l.3.9a.9.9,0,0,0,.8.7h.8a.9.9,0,0,0,.9-.9V9.4A.9.9,0,0,0,68.9,8.6Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3,8.2a9.5,9.5,0,0,0-3.7.8h0V2.4a1.1,1.1,0,0,0-.9-.9H73.8a.9.9,0,0,0-.9.9V23.3a.9.9,0,0,0,.9.9h.8a.8.8,0,0,0,.8-.8l.3-.8a8,8,0,0,0,5,2c4,0,7.3-3.7,7.3-8.2a8,8,0,0,0-7.6-8.2Zm-3.8,4.3a8.1,8.1,0,0,1,3.4-.8,4.6,4.6,0,0,1,4.4,4.7A4.2,4.2,0,0,1,76.5,19Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1,1.5h1.8a.9.9,0,0,1,.9.9V23.3a.9.9,0,0,1-.9.9H91.1a.9.9,0,0,1-.9-.9V2.4A.9.9,0,0,1,91.1,1.5Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8,8.6h1.9a.9.9,0,0,1,.9.8V23.3a.9.9,0,0,1-.9.9H97.8a.9.9,0,0,1-.9-.9V9.4a.9.9,0,0,1,.9-.8Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7,1.5a2.3,2.3,0,0,0-2.3,2.3h0a2.4,2.4,0,0,0,2.3,2.4h0a2.4,2.4,0,0,0,2.4-2.4,2.4,2.4,0,0,0-2.4-2.4Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8,14.7c-1.7-.7-2.6-1.2-2.6-2.1s.6-1.2,1.9-1.2a8.8,8.8,0,0,1,3.2.7.9.9,0,0,0,1.2-.3h0l.5-1.1a1,1,0,0,0-.4-1.3,8.9,8.9,0,0,0-4.5-1.2c-3.7,0-5.3,2.2-5.3,4.4s2.1,4,4.3,4.9,3.2,1.7,3.2,2.6-.8,1.3-1.9,1.3a7,7,0,0,1-3.7-1.1h-.1a.9.9,0,0,0-.7-.1.7.7,0,0,0-.5.4l-.7,1.4a.9.9,0,0,0,.3,1h0a9.9,9.9,0,0,0,5.2,1.6c3.7,0,5.6-2.4,5.6-4.7S111.8,16,108.8,14.7Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7,8.2a7.2,7.2,0,0,0-4.3,1.5V2.4a.9.9,0,0,0-.9-.9h-1.8a.9.9,0,0,0-.9.9V23.3a.9.9,0,0,0,.9.9h1.8a.8.8,0,0,0,.9-.8h0V13.8a4.6,4.6,0,0,1,3.9-2.1c1.8,0,2.9,1.4,2.9,3.9v7.7a.9.9,0,0,0,.9.9h1.8a.9.9,0,0,0,.9-.9V15.6C129.8,10.8,127.7,8.2,123.7,8.2Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.6,8.6h1.8a.9.9,0,0,1,.9.8V23.3a.9.9,0,0,1-.9.9h-1.8a.9.9,0,0,1-.9-.9V9.4a.9.9,0,0,1,.9-.8Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5,1.5a2.3,2.3,0,0,0-2.4,2.3h.1a2.3,2.3,0,0,0,2.2,2.4h.1a2.4,2.4,0,0,0,2.4-2.4,2.4,2.4,0,0,0-2.4-2.4Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.3,8.2a7.4,7.4,0,0,0-5.1,2l-.4-1.1a.7.7,0,0,0-.8-.5h-.8a.9.9,0,0,0-.8.8V23.3a.9.9,0,0,0,.8.9h1.7c.7,0,1.1-.3,1.1-.9V13.8a4.6,4.6,0,0,1,3.9-2.1c1.8,0,2.9,1.3,2.9,3.8v7.8a.9.9,0,0,0,.8.9h1.9a.9.9,0,0,0,.9-.9V15.6C153.4,10.6,151.4,8.2,147.3,8.2Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.5,8.6h-.8a.8.8,0,0,0-.8.6l-.3.7a7.4,7.4,0,0,0-4.8-1.7c-4.1,0-7.4,3.6-7.4,8.2s3.4,8.2,7.6,8.2a8.6,8.6,0,0,0,3.8-1v.6c0,3.3-2,3.9-3.7,3.9a5.2,5.2,0,0,1-3.5-1.4.9.9,0,0,0-.7-.1.7.7,0,0,0-.6.4l-.8,1.5a.9.9,0,0,0,.2,1,8.7,8.7,0,0,0,5.5,2c4.4,0,7.2-2.8,7.2-7.3V9.4A.9.9,0,0,0,169.5,8.6Zm-6.1,12.5a4.5,4.5,0,0,1-4.3-4.7,4.2,4.2,0,0,1,7.7-2.7V20A6,6,0,0,1,163.4,21.1Z",
    fill: "#444"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.9.5C3.6.5.5,3.6.5,15.9S3.6,31.3,15.9,31.3s15.4-3.1,15.4-15.4S28.2.5,15.9.5Z",
    fill: "url(#linear-gradient--publishing)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 9.6,
    width: 3,
    height: 12.58,
    rx: 0.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 19.2,
    width: 9,
    height: 2.99,
    rx: 0.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 9.6,
    width: 9,
    height: 7.2,
    rx: 0.7,
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishingBadgeColor);
export default __webpack_public_path__ + "static/media/publishing-badge-color.f4f2303f1631af543552a825257f217f.svg";
export { ForwardRef as ReactComponent };